/** @jsx jsx */
import { DottedListItem, Flex, FullScreenModalHeader, Heading, Link } from "@eworkit/iris";
import { useBreakpointIndex } from "@theme-ui/match-media";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link as ReactRouterLink } from "react-router-dom";
import { jsx } from "theme-ui";

import { JobRequest } from "@/data/job-requests/types/JobRequest";
import { formatFullName } from "@/data/persons";
import { JobRequestHeader } from "@/views/job-requests/header/JobRequestHeader";
import { router } from "@/views/router";

import { ApplyModalSavingIndicator } from "./ApplyModalSavingIndicator";
import { useApplyWizard } from "./ApplyWizardContext";

interface ApplyModalHeaderProps {
  jobRequest: JobRequest;
  header: string;
  onCloseClick?: () => void;
}

export const ApplyModalHeader: FC<ApplyModalHeaderProps> = ({ jobRequest, header, onCloseClick }) => {
  const { t } = useTranslation("session");

  const breakpoint = useBreakpointIndex();

  const { profile } = useApplyWizard();

  return (
    <FullScreenModalHeader
      onCloseClick={onCloseClick}
      closeButtonAriaLabel={t("COMPONENTS.MODAL.CLOSE")}
      sx={{
        "&[data-component='dialog-header']": {
          px: "sm",
          py: [null, null, null, "sm"],
          height: [93, null, null, 75],

          "& > button": {
            alignSelf: "center",
          },
        },
      }}>
      <Flex flexGrow={1} justifyContent="space-between" alignItems="center" gap="sm">
        {breakpoint > 2 ? (
          <JobRequestHeader jobRequest={jobRequest} header={header}>
            {profile && (
              <DottedListItem>
                <Link
                  as={ReactRouterLink}
                  to={
                    router.get("consultant-profiles.detail", {
                      consultantProfileId: profile.parent?.id ?? profile.id,
                    }).path
                  }
                  target="_blank">
                  {formatFullName(profile)}
                </Link>
              </DottedListItem>
            )}
          </JobRequestHeader>
        ) : (
          <Heading
            size="h-sm"
            sx={{
              lineClamp: 2,
              WebkitLineClamp: 2,
              display: "-webkit-box",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitBoxOrient: "vertical",
            }}>
            {header}
          </Heading>
        )}

        <ApplyModalSavingIndicator />
      </Flex>
    </FullScreenModalHeader>
  );
};
